import React from 'react';

const ArrowRightIcon = ({ className }) => (
  <svg
    className={className}
    width="6"
    height="9"
    viewBox="0 0 6 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.494141 0.493652L4.49414 4.49365L0.494141 8.49365"
      stroke="currentColor"
      strokeWidth="0.987374"
      strokeLinecap="round"
    />
  </svg>
);

export default ArrowRightIcon;

